import { StoresRepository } from '~repositories/StoresRepository';
import { UserLocationRepository } from '~repositories/UserLocationRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';
import { Config } from '~domain/entities/Config';

export class StoreDetailsLoadedUseCase {
    private storeId: string;
    private storesRepository: StoresRepository;
    private userLocationRepository: UserLocationRepository;
    private configService: Config;

    constructor(storeId: string) {
        this.storeId = storeId;
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
        this.userLocationRepository = diContainer.get(serviceNames.userLocationRepository);
        this.configService = diContainer.get(serviceNames.config);
    }

    public execute = async () => {
        await this.userLocationRepository.getUserLocation();
        const { geolocation: userLocation } = this.userLocationRepository.userLocation;
        const { storesDefaultSearchLocation } = this.configService.config;

        return this.storesRepository.loadStoreById(
            this.storeId,
            userLocation || storesDefaultSearchLocation
        );
    };
}
